import React from "react";
import { Link } from "react-router-dom";
import "./AlertSidebar.css";
import { buildAlertSentence } from "./alert-utils";
import { ALERT_STATUS } from "./alert-types";

export default function AlertSidebar({
  open = true,
  alerts = [],
  onToggle = () => {},
  onOpenHistory = () => {},
  onConfirm = () => {},
  busyIds = [],
}) {
  const collapsed = !open;
  const unreadCount = alerts.filter((item) => item.status === ALERT_STATUS.ALERT).length;
  const nowLabel = new Date().toLocaleString();
  const busySet = new Set(busyIds);

  if (collapsed) {
    return (
      <div className="alert-sidebar-top" aria-label="이상 알림">
        <button type="button" className="alert-sidebar__toggle" onClick={onToggle} title="알림 열기">
          <b className="alert-toggle-btn">
            <svg viewBox="-2 -3 32 32" style={{'width':'100%'}} preserveAspectRatio="none" fill="none">
              <path d="M12 5.5C14.7614 5.5 17 7.73858 17 10.5V12.7396C17 13.2294 17.1798 13.7022 17.5052 14.0683L18.7808 15.5035C19.6407 16.4708 18.954 18 17.6597 18H6.34025C5.04598 18 4.35927 16.4708 5.21913 15.5035L6.4948 14.0683C6.82022 13.7022 6.99998 13.2294 6.99998 12.7396L7 10.5C7 7.73858 9.23858 5.5 12 5.5ZM12 5.5V3M10.9999 21H12.9999" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </b>
          <span classname="no-read-cnt">{unreadCount}</span>
        </button>
      </div>
    );
  }

  return (
    <aside className="alert-sidebar" aria-label="이상 알림" aria-live="polite">
      <div className="alert-sidebar-top">
        <button type="button" className="alert-sidebar__toggle" onClick={onToggle} title="알림 닫기">
          <b className="alert-toggle-btn">
            <svg viewBox="-2 -3 32 32" style={{'width':'100%'}} preserveAspectRatio="none" fill="none">
              <path d="M12 5.5C14.7614 5.5 17 7.73858 17 10.5V12.7396C17 13.2294 17.1798 13.7022 17.5052 14.0683L18.7808 15.5035C19.6407 16.4708 18.954 18 17.6597 18H6.34025C5.04598 18 4.35927 16.4708 5.21913 15.5035L6.4948 14.0683C6.82022 13.7022 6.99998 13.2294 6.99998 12.7396L7 10.5C7 7.73858 9.23858 5.5 12 5.5ZM12 5.5V3M10.9999 21H12.9999" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </b>
          <span classname="no-read-cnt">{unreadCount}</span>
        </button>
      </div>

      <header className="alert-sidebar__header">
        <div>
          <h2>현재 이상 알림<small>{alerts.length}건</small></h2>
          <small>{nowLabel}</small>
        </div>
        
        <button type="button" className="alert-sidebar__history" onClick={onOpenHistory}>
          알림 상세 보기
        </button>

      </header>

      

      <div className="alert-sidebar__list">
        {!alerts.length ? (
          <p className="alert-sidebar__empty">현재 표시할 이상 알림이 없습니다.</p>
        ) : (
          alerts.map((item) => {
            const unread = item.status === ALERT_STATUS.ALERT;
            const busy = busySet.has(item.id);
            return (
              <article
                key={item.id}
                className={`alert-card ${unread ? "is-alert" : "is-acknowledged"}`}
              >
                <div className="alert-card__head">
                  <div>
                    {item.detail_url ? (
                      <Link to={item.detail_url} className="alert-card__link">
                        {item.device_display_key || item.item_name || item.device_name || item.device_key}
                      </Link>
                    ) : (
                      <strong>{item.device_display_key || item.item_name || item.device_name || item.device_key}</strong>
                    )}
                    {item.metric_label ? <span>{item.metric_label}</span> : null}
                  </div>
                  <div className="alert-card__actions">
                    <em>{unread ? "미확인" : "확인됨"}</em>
                    {unread ? (
                      <button type="button" onClick={() => onConfirm(item)} disabled={busy}>
                        {busy ? "처리중" : "확인"}
                      </button>
                    ) : null}
                  </div>
                </div>
                <p>{buildAlertSentence(item)}</p>
                {item.detected_at ? <small>{item.detected_at}</small> : null}
              </article>
            );
          })
        )}
      </div>
    </aside>
  );
}
